import { Text } from '@belong/ui';
import clsx from 'clsx';
import css from './blog-tags.module.css';

type BlogTagsProps = {
  tags: string[];
  showAllTags?: boolean;
  limitWidth?: boolean;
};

function getTags(tags: string[], showAllTags: boolean): string[] {
  const hashtags = tags.filter((tag) => tag.toLowerCase() !== 'featured');
  if (hashtags.length <= 2 || showAllTags) {
    return hashtags;
  }
  return [...hashtags.slice(0, 2), `+${hashtags.length - 2}`];
}

// Think about these props?
export function BlogTags({ tags, showAllTags = false, limitWidth = false }: BlogTagsProps): JSX.Element {
  return (
    <div className={clsx({ [css.tagsContainer]: limitWidth }, 'flex flex-wrap w-full')}>
      {getTags(tags, showAllTags).map((tag, idx) => (
        <div className="h-full pt-2xs px-xs mt-xs mr-xs last:mr-0 bg-navy-translucent-light rounded-small" key={idx}>
          <Text variant="p1" fontWeight="semibold" className="truncate">
            {tag}
          </Text>
        </div>
      ))}
    </div>
  );
}
